
import { scrollIt } from '../library';

export default class SearchBar {

  constructor() {

    this.toggle = false;

    this.defaultMode = 'content';

    this.toggleElm = document.getElementById("search_toggle");
    if (!!this.toggleElm) {
      this.setup();
    }

    this.submitForm = this.submitForm.bind(this);
  }

  updateValue(e) {
    const val = e.target.checked;
    if (val) {
      document.body.classList.add('search-bar-open');
      scrollIt(0);
      document.getElementById('edit-keys').focus();
    }
    else {
      document.body.classList.remove('search-bar-open');
    }
  }

  submitForm(e) {
    e.preventDefault();

    const form = e.target;
    const modeSwitch = form.querySelector('.search-mode-switch');
    const mode = modeSwitch ? modeSwitch.value : this.defaultMode;

    if (mode === 'product') {
      const searchTxt = form.querySelector('[name=keys]');
      let val = '';

      if ((val = searchTxt.value)) {
        window.location.href = '/products?search=' + encodeURIComponent(val);
      }
      else {
        searchTxt.focus();
      }
    } else {
      form.submit();
    }
  }

  setup() {
    this.toggleElm.addEventListener('change', this.updateValue);

    document.getElementById('close-search-bar').addEventListener('click', () => {
      document.body.classList.remove('search-bar-open');
      this.toggleElm.checked = false;
    })

    // var form = document.getElementById('search-api-page-block-form-contents');

    var forms = document.querySelectorAll('.search-api-page-block-form-contents > form');

    Array.from(forms).forEach((form) => form.addEventListener('submit', this.submitForm));

    var altForm = document.querySelector('form.search-api-page-block-form-contents')
    !!altForm && altForm.addEventListener('submit', this.submitForm);

    // var switchSearchOption = document.getElementById("edit-search-option");
    // !!switchSearchOption && switchSearchOption.addEventListener('change', function (e) {
    //
    // })
  }
}
